import { rateWithCommas } from 'utils/NumberCommaSeprator';

const EMPTY = '—';

/** 'per_bag' -> 'Per Bag'. */
export const formatChargeBasis = (basis) =>
	(basis || '')
		.split('_')
		.filter(Boolean)
		.map((word) => word[0].toUpperCase() + word.slice(1))
		.join(' ') || EMPTY;

/** One additional charge, e.g. "Cross Dock - Per Bag - ₹ 10". */
const formatCharge = (charge) =>
	[
		charge.charge_head || EMPTY,
		formatChargeBasis(charge.basis),
		charge.rate === null || charge.rate === undefined
			? EMPTY
			: `₹ ${rateWithCommas(charge.rate)}`,
	].join(' - ');

const isCharge = (item) => item !== null && typeof item === 'object' && 'charge_head' in item;

const formatObject = (value) =>
	Object.entries(value)
		.map(([key, item]) => `${key}: ${item}`)
		.join(', ');

/**
 * What a Revenue / Cost Edit Log cell shows for a changed value. Most values are plain numbers
 * or text, but the additional charges are saved as a list of charge objects, which String()
 * turns into "[object Object]".
 */
export const formatEditLogValue = (value) => {
	if (value === null || value === undefined || value === '') return EMPTY;
	if (Array.isArray(value)) {
		if (value.length === 0) return 'None';
		return value
			.map((item) => (isCharge(item) ? formatCharge(item) : formatEditLogValue(item)))
			.join('; ');
	}
	if (typeof value === 'object')
		return isCharge(value) ? formatCharge(value) : formatObject(value);
	return String(value);
};
